// components
import GridPageAbstract from '../../abstract/GridPageAbstract';

export default class CryptoCoinsPage extends GridPageAbstract {
    constructor(props) {
        super(props);

        this.Name = 'cryptoCoins';
        this.Server = this.props.context.getState().server.cryptoCoins;
        this.MenuDisplayType = 'menu';
        this.searchFields = ['friendlyName', 'chain', 'coin'];
        this.exportButton = true;

        this.Head = localStorage[`head_${this.Name}`]
            ? JSON.parse(localStorage[`head_${this.Name}`])
            : [
                {
                    id: 'friendlyName',
                    label: 'friendlyName',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'chain',
                    label: 'chain',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'chainScannerLink',
                    label: 'chainScannerLink',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'coin',
                    label: 'coin',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'tokenContractAddress',
                    label: 'tokenContractAddress',
                    alignRight: false,
                    cell: 'Text',
                    displayGrid: true
                },
                {
                    id: 'modifiedReason',
                    label: 'modifiedReason',
                    alignRight: false,
                    cell: 'BigText',
                    displayGrid: true,
                    disableEditor: true,
                },
                {
                    id: 'modifiedBy',
                    label: 'modifiedBy',
                    alignRight: false,
                    cell: 'Select',
                    object: 'modifiedBy',
                    show: 'firstName+lastName',
                    displayGrid: true,
                    disableEditor: true,
                    customSort: 'modifiedBy.firstName',
                },
                {
                    id: 'dateCreatedModified',
                    elements: ['dateCreated', 'dateModified'],
                    label: 'dateCreatedModified',
                    alignRight: false,
                    cell: 'CreateModify',
                    disableEditor: true,
                    displayGrid: true,
                    customSort: 'dateCreated',
                }
            ];
        this.state = {
            ...this.state,
            head: this.Head
        };
    }
}
